<template>
  <b-row
    align-v="center"
    @mouseover="setContextOnHover(contextHelpRoot+'Current')"
    @mouseleave="setContextOnHover(contextHelpRoot+'Current')"
  >
    <b-col class="m-0">
      <p class="label">
        X-axis
      </p>
    </b-col>
    <b-col class="m-0">
      <SimpleDropdownConfiguration :controller="InputX" />
    </b-col>
    <b-col class="m-0">
      <SimpleDropdownConfiguration :controller="OutputX" />
    </b-col>
    <b-col class="m-0">
      <CheckBoxConfiguration
        :controller="LogX_axis"
        :switchprop="true"
      />
    </b-col>
  </b-row>
</template>

<script>
import {comboBoxConfCtrller, checkBoxGraphConfCtrller} from '@/assets/classes/configuration.js'
import SimpleDropdownConfiguration from '../elements/SimpleDropdownConfiguration'
import CheckBoxConfiguration from '../elements/CheckBoxConfiguration'
import { ConfigName } from '@/common/sharedDefinitions/commonPlotDefinitions'
import { mapActions } from 'vuex'

const contextHelpRoot='ReportViewer/Units/'
export default {
  name: 'GenericXConfiguration',
  components: { 
    SimpleDropdownConfiguration,
    CheckBoxConfiguration
  },
  data () {
    return {
      InputX: new comboBoxConfCtrller(ConfigName.GenericXAxisInputUnit,
        [
          {text:'G',value:9},
          {text:'M',value:6},
          {text:'k',value:3},
          {text:'1',value:0},
          {text:'m',value:-3},
          {text:'μ',value:-6},
          {text:'n',value:-9},
        ],'Input Magnitude',3,`${contextHelpRoot}InputX`,true),
      OutputX:  new comboBoxConfCtrller(ConfigName.GenericXAxisOutputUnit,
        [
          {text:'G',value:9},
          {text:'M',value:6},
          {text:'k',value:3},
          {text:'1',value:0},
          {text:'m',value:-3},
          {text:'μ',value:-6},
          {text:'n',value:-9},
        ],'Output Magnitude',3,`${contextHelpRoot}OutputX`,true),
      LogX_axis: new checkBoxGraphConfCtrller(`${ConfigName.BaseAxisProperties}.LOGX_BOOL`,'LogX Axis',false,contextHelpRoot+'Log_axis'),
      elementsConfig:[],
      contextHelpRoot
    }
  },
  mounted(){
    this.elementsConfig=[
      this.InputX,
      this.OutputX,
      this.LogX_axis
    ]
    this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
    this.elementsConfig.forEach(conf=>conf.setParent(this))
  },
  methods:mapActions(['setContextOnHover','setConfigReportModifiedReportViewer']),
}
</script>

<style lang="scss" scoped>
.label{
  margin:0px;
  font-size: 0.8rem;
}

.header{
  font-weight: bold;
  font-size: 0.9rem;
  margin-bottom: 0.35rem;
}
::v-deep .label-input-text{
  font-size: 0.8rem;
}
</style>